import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
    selector: 'insight-detail',
    templateUrl: './insight-detail.component.html',
    styleUrls: ['./insight-detail.component.css']
})

export class InsightDetailComponent implements OnInit {

    // Default alertTimePeriod is ALL
    alertTimePeriod = 'a';
    showRanges = true;
    deviceIP: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.route.params
        .subscribe((params: Params) => this.deviceIP = params['ip']);
/*
        this.deviceIP = this.route.snapshot.params['ip'];
        console.log('Device IP = ', this.deviceIP);
*/
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/insight-detail/insight-detail.component.ts